/** @format **/
import { PlatformIccidRmoHistoryCollection } from '../../interfaces/collections/PlatformIccidRmoHistory';
import { PlatformIccidPoolNumber } from '../../interfaces/platform/PlatformIccidPoolNumber';
import { PlatformIccidPoolNumberCollectionInterface } from '../../interfaces/collections/PlatformIccidPoolNumberCollectionInterface';

export const PlatformIccidMsisdnIpPoolReducerAction = {
    GET_RMO_HISTORY_LIST: 'GET_RMO_HISTORY_LIST',
    RMO_MODEL_CHANGE: 'RMO_MODEL_CHANGE',
    RMO_MODEL_MVNE_CHANGE: 'RMO_MODEL_MVNE_CHANGE',
    RMO_MODEL_PARTNER_CHANGE: 'RMO_MODEL_PARTNER_CHANGE',
    RMO_CHANGE_OPEN_DIALOG_ADVANCED: 'RMO_CHANGE_OPEN_DIALOG_ADVANCED',
    RMO_RELOAD_MAIN_LIST_AFTER_CHANGE_RMO: 'RMO_RELOAD_MAIN_LIST_AFTER_CHANGE_RMO',
    RMO_CHANGE_OPEN_DIALOG_ADVANCED_RANGE_COUNTER: 'RMO_CHANGE_OPEN_DIALOG_ADVANCED_RANGE_COUNTER',
    INDICATED_RANGE_CHANGE_OPEN_DIALOG_ADVANCED: 'INDICATED_RANGE_CHANGE_OPEN_DIALOG_ADVANCED',
    INDICATED_RANGE_RELOAD_MAIN_LIST_AFTER_CHANGE: 'INDICATED_RANGE_RELOAD_MAIN_LIST_AFTER_CHANGE',
    IMSI_CHANGE_OWNER_OPEN_DIALOG_ADVANCED: 'IMSI_CHANGE_OWNER_OPEN_DIALOG_ADVANCED',
    IMSI_OWNER_CHANGE: 'IMSI_OWNER_CHANGE',
    MSISDN_CHANGE_OWNER_OPEN_DIALOG_ADVANCED: 'MSISDN_CHANGE_OWNER_OPEN_DIALOG_ADVANCED',
    MSISDN_OWNER_CHANGE: 'MSISDN_OWNER_CHANGE',
    IP_CHANGE_OWNER_OPEN_DIALOG_ADVANCED: 'IP_CHANGE_OWNER_OPEN_DIALOG_ADVANCED',
    IP_OWNER_CHANGE: 'IP_OWNER_CHANGE',

    IMSI_RELOAD_MAIN: 'IMSI_RELOAD_MAIN',
    IMSI_DETAIL_LOAD: 'IMSI_DETAIL_LOAD',
    RMO_MODEL_NO_ACTION: 'RMO_MODEL_NO_ACTION',
    IMSI_CHANGE_OWNER_RELOAD: 'IMSI_CHANGE_OWNER_RELOAD',
    MSISDN_CHANGE_OWNER_RELOAD: 'MSISDN_CHANGE_OWNER_RELOAD',
    IP_CHANGE_OWNER_RELOAD: 'IP_CHANGE_OWNER_RELOAD',
};

export type PlatformIccidMsisdnIpPoolReducerType = {
    type: string;
    collectionIccidRmoHistory?: PlatformIccidRmoHistoryCollection;
    imsiItem?: PlatformIccidPoolNumber | null;
    valueChange?: boolean;
    selectedValue?: string | number;
    openChangeRmoAdv?: boolean;
    openImsiChangeOwner?: boolean;
    openMsisdnChangeOwner?: boolean;
    openIpChangeOwner?: boolean;
    openChangeIndicateRangeAdv?: boolean;
};

export type PlatformIccidPoolCounterReducerType = {
    type: string;
    counter: PlatformIccidPoolNumberCollectionInterface;
};

export const platformIccidMsisdnIpPoolReducer = (
    state: any,
    action: PlatformIccidMsisdnIpPoolReducerType | PlatformIccidPoolCounterReducerType
): object => {
    switch (action.type) {
        case PlatformIccidMsisdnIpPoolReducerAction.GET_RMO_HISTORY_LIST:
        case PlatformIccidMsisdnIpPoolReducerAction.IMSI_DETAIL_LOAD:
        case PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_CHANGE:
        case PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_MVNE_CHANGE:
        case PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_PARTNER_CHANGE:
        case PlatformIccidMsisdnIpPoolReducerAction.IMSI_RELOAD_MAIN:
        case PlatformIccidMsisdnIpPoolReducerAction.RMO_CHANGE_OPEN_DIALOG_ADVANCED:
        case PlatformIccidMsisdnIpPoolReducerAction.INDICATED_RANGE_CHANGE_OPEN_DIALOG_ADVANCED:
        case PlatformIccidMsisdnIpPoolReducerAction.RMO_CHANGE_OPEN_DIALOG_ADVANCED_RANGE_COUNTER:
        case PlatformIccidMsisdnIpPoolReducerAction.IMSI_CHANGE_OWNER_OPEN_DIALOG_ADVANCED:
        case PlatformIccidMsisdnIpPoolReducerAction.MSISDN_CHANGE_OWNER_OPEN_DIALOG_ADVANCED:
        case PlatformIccidMsisdnIpPoolReducerAction.IMSI_OWNER_CHANGE:
        case PlatformIccidMsisdnIpPoolReducerAction.MSISDN_OWNER_CHANGE:
        case PlatformIccidMsisdnIpPoolReducerAction.IP_CHANGE_OWNER_OPEN_DIALOG_ADVANCED:
        case PlatformIccidMsisdnIpPoolReducerAction.IP_OWNER_CHANGE:
            return {
                ...state,
                ...action,
            };
        case PlatformIccidMsisdnIpPoolReducerAction.RMO_RELOAD_MAIN_LIST_AFTER_CHANGE_RMO:
        case PlatformIccidMsisdnIpPoolReducerAction.INDICATED_RANGE_RELOAD_MAIN_LIST_AFTER_CHANGE:
        case PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_NO_ACTION:
        case PlatformIccidMsisdnIpPoolReducerAction.IMSI_CHANGE_OWNER_RELOAD:
        case PlatformIccidMsisdnIpPoolReducerAction.MSISDN_CHANGE_OWNER_RELOAD:
        case PlatformIccidMsisdnIpPoolReducerAction.IP_CHANGE_OWNER_RELOAD:
            return {
                type: action.type,
            };
        default:
            return { ...state };
    }
};
